import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {IDimConfig} from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import {Point} from "pixi.js";
import {NineSliceButton} from "@nolimitcity/slot-game/bin/core/component/NineSliceButton";
import {IBackPlateMeshConfig} from "@nolimitcity/slot-game/bin/core/displayobject/BasePlateMesh";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {SoundManager} from "../../resource/sound/SoundManager";
import {WGSoundConfig} from "../../WGSoundConfig";


export class ContinueButton extends BaseView {

    public static continueDim: IDimConfig = {
        dimOrientation: {
            landscape: {
                scale: new Point(1, 1),
                position: new Point(360, 550),
                layout: {
                    left: new Point(31, 550),
                    right: new Point(360, 550)
                }
            },
            portrait: {
                scale: new Point(1, 1),
                position: new Point(360, 600)
            }
        },
        WIDTH: 240,
        HEIGHT: 64,
    };
    protected readonly DEFAULT_BUTTON_TEXT_STYLE: TextStyleOptions = {
        fontFamily: "Open Sans",
        fontStyle: FontStyle.ITALIC,
        fontSize: 34,
        fill: "#ffffff",
        fontWeight: FontWeight.EXTRA_BOLD
    };
    protected readonly DEFAULT_BTN_BACKGROUND: IBackPlateMeshConfig = {
        cornerRadius: 12,
        lineThickness: 2,
        lineColor: 0xffffff,
        lineAlpha: 1,
        backgroundColor: 0x000000,
        backgroundAlpha: 0.9
    };
    private callbackFn: Function;

    constructor(callbackFn: Function) {
        super();
        this.callbackFn = callbackFn;
        this.createContinue();
    }

    protected createContinue(): NineSliceButton {
        const text: string = Translation.translate("CONTINUE");
        const textStyle: TextStyleOptions = this.DEFAULT_BUTTON_TEXT_STYLE;
        const button = new NineSliceButton(() => {
            this.callbackFn();
            SoundManager.playSoundEffect(WGSoundConfig.instance.CONTINUE_BUTTON_SOUND);
        }, ` ${text} `, textStyle, this.DEFAULT_BTN_BACKGROUND);
        button.setSize(ContinueButton.continueDim.WIDTH, ContinueButton.continueDim.HEIGHT, 1);
        button.enabled = true;
        this.addChild(button);
        return button;
    }
}
